import { useId, useState } from "react";
import { FiHelpCircle } from "react-icons/fi";
import { cn } from "@/shared/lib";

export interface FormFieldHelpProps {
  label: string;
  helpText: string;
  className?: string;
}

/** フォーム項目の補足説明を、ホバー・フォーカス・タップで表示する。 */
export const FormFieldHelp: React.FunctionComponent<FormFieldHelpProps> = ({
  label,
  helpText,
  className,
}: FormFieldHelpProps) => {
  const tooltipId = useId();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <span
      className={cn(
        "group relative inline-flex shrink-0",
        className ?? "ml-auto",
      )}
    >
      <button
        type="button"
        aria-label={`${label}の説明を表示`}
        aria-controls={tooltipId}
        aria-describedby={tooltipId}
        aria-expanded={isTooltipOpen}
        onClick={(): void => setIsTooltipOpen((isOpen) => !isOpen)}
        onBlur={(): void => setIsTooltipOpen(false)}
        className="desktop-floating-help-trigger inline-flex h-6 min-h-6 w-6 min-w-6 cursor-help items-center justify-center rounded text-current focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-current"
      >
        <FiHelpCircle aria-hidden="true" className="h-4 w-4" />
      </button>
      <span
        id={tooltipId}
        role="tooltip"
        className={cn(
          "invisible absolute left-full top-1/2 z-50 ml-2 w-max max-w-64 -translate-y-1/2 whitespace-pre-line rounded-md border border-border bg-card px-3 py-2 text-xs font-normal text-card-foreground opacity-0 shadow-lg group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100",
          isTooltipOpen && "visible opacity-100",
        )}
      >
        {helpText}
      </span>
    </span>
  );
};

FormFieldHelp.displayName = "FormFieldHelp";
